import {DOM} from	'../helpers/DOM.js';

export default class DatePicker {
	#datePickers = [];
	#clearButton;
	#clearInputValue;
	constructor() {
			this.#clearButton = document.querySelectorAll("button.clear_input_value_button");
			this.#clearInputValue = document.querySelectorAll("input.clear_item_value");
			if(this.#clearButton && this.#clearInputValue){
				this.addEventsClearButton();
			}

		if (DOM.el('input[data-lev-datepicker]')) {
			this.#initialize();
			this.formWrapper = DOM.el('.levcharity-multi-step-form-wrapper, .donor_crm_edit_wrapper #primary_form, #fieldset-custom-meta_levcharity_custom_field, .woocommerce-EditAccountForm.edit-account')
			DOM.addEvent('RepeaterItemAdded', this.formWrapper, () => {
				this.#initialize();
			});
		}
	}

	addEventsClearButton(){
		this.#clearButton.forEach(button => {
			button.addEventListener('click', (event) => {
				let parentElement = event.target.offsetParent;
				if(parentElement){
					let input = parentElement?.querySelector('input.clear_item_value');
					if(input){
						input.value = '';
						button.style.display = "none"
					}
				}
			})
			this.#clearInputValue.forEach(input => {
				input.addEventListener('input', (event) => {
					let parentElement = event.target.offsetParent;
						if(parentElement){
							let button = parentElement?.querySelector('button.clear_input_value_button');
							if(button){
								button.style.display = 'inline';
							}
						}
				})
			})
		})

	}
	async #initialize() {
		const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */);
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);

		DOM.els('input[data-lev-datepicker]:not([data-initialized])')
			.forEach(element => {
				element.type = 'text';

				const type = element.dataset?.levDatepicker || 'grigorian';
				const format = element.dataset?.levDatepickerFormat || '';
				const isRangeEnabled = element.dataset?.range === 'true';
				const grid = parseInt(element.dataset?.grid || 1);

				let lock = null;

				let minDate = element.dataset?.levDatepickerMinDate || undefined;
				let maxDate = element.dataset?.levDatepickerMaxDate || undefined;

				if (minDate || maxDate) {
					if (minDate) {
						const date = new Date();
						date.setTime(Helper.strtotime(minDate) * 1000 - (24 * 60 * 60 * 1000))
						minDate = date;
					}
					if (maxDate) {
						const date = new Date();
						date.setTime(Helper.strtotime(maxDate) * 1000)
						maxDate = date;
					}

					lock = {
						minDate,
						maxDate,
						minDays: 0,
						maxDays: 0,
						presets: true // should lock presets
					}
				}

				Components.datePicker({
					inputElement: element,
					calendar: type,
					levFormat: format,
					lock,
					range: isRangeEnabled,
					gridColumns: grid,
					showMonths: grid,
				});

				element.dataset.initialized = true;
			})
	}
}
